import { useContext } from "react";
import { ConfiguratorContext } from "../context";

/**
 * Hook para manejo de datos de enlaces
 * Proporciona acceso a los enlaces de navegación del configurador
 */
const useLinksData = () => {
    const [state, setState] = useContext(ConfiguratorContext);

    // Obtiene los enlaces disponibles
    const getLinks = () => (state.links ? state.links : null);

    // Obtiene la URL base del configurador
    const getBasename = () => state.basename || "";

    return {
        getLinks,
        getBasename,
    };
};

export default useLinksData;
